import * as Sentry from '@sentry/react';

import {Version} from '_/hooks/useVersionInfo';

const SENTRY_CONFIG_PATH = '/sentryConfig.json';

export type SentryConfiguration = {
  enabled: boolean;
  dsn?: string;
  environment?: string;
  frontendVersion?: string;
};

let initialized = false;

const fetchSentryConfiguration = async (): Promise<SentryConfiguration> => {
  try {
    const response = await fetch(SENTRY_CONFIG_PATH);
    const body = await response.json();
    return body as SentryConfiguration;
  } catch {
    return {enabled: false};
  }
};

export const setupSentry = async (version: Version): Promise<void> => {
  if (!initialized) {
    initialized = true;

    const config = await fetchSentryConfiguration();
    if (config.enabled) {
      Sentry.init({
        dsn: config.dsn,
        environment: config.environment,
        release: version.frontend,

        initialScope: {
          tags: {
            component: 'webapp',
          },
        },
      });

      Sentry.addGlobalEventProcessor(
        (event) =>
          // user is tracked via application/index.tsx

          // filter events or extend event info

          event
      );
    }
  }
};
